export const MAP_LP_TO_SLIDES_MSG = 'lp:map-lp-to-slides-msg';
export const GET_MAPPED_LP_FROM_SLIDES_MSG = 'lp:get-mapped-lp-from-slides-msg';
export const UPDATE_DRAFT_LP_MSG = 'lp:update-draft-lp-msg';
export const LOGIN_SUCCESS_MSG = 'lp:login-success-msg';
